import React from 'react';
import { useCriticalEvents } from '@src/services/queries';
import styled from 'styled-components';
import { Tag } from 'antd';

const RuleTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #1890ff;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EventContainer = styled.div`
  margin-top: 8px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 4px;
  font-family: monospace;
  font-size: 12px;
  word-break: break-all;
`;

const formatJSON = (obj: any) => {
  const { value, mapping_rules } = obj;
  const event = {
    event_name: value?.[0],
    event_tags: mapping_rules,
  };
  const replacer = (key: string, value: any) => {
    if (value === undefined) return 'undefined';
    if (value === null) return 'null';
    return value;
  };
  try {
    const formatted = JSON.stringify(event, replacer, 2)
      .replace(/\n/g, '<br/>')
      .replace(/ /g, '&nbsp;')
      .replace(/[{]/g, '<span style="color: #666">{</span>')
      .replace(/[}]/g, '<span style="color: #666">}</span>')
      .replace(/[[\]]/g, (match) => `<span style="color: #666">${match}</span>`)
      .replace(/"([^"]+)":/g, '<span style="color: #2a5fb0">"$1"</span>:')
      .replace(/: "([^"]+)"/g, ': <span style="color: #1a8b1a">"$1"</span>')
      .replace(/: ([0-9.]+)/g, ': <span style="color: #1a8b1a">$1</span>');
    return formatted;
  } catch {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    return String(event);
  }
};

interface EventRuleViewerProps {
  name: string;
  rule?: any;
}

const EventRuleViewer: React.FC<EventRuleViewerProps> = ({ name, rule }) => {
  const { data } = useCriticalEvents();
  const eventRule = rule ?? data?.criticalEvents.find((event) => event.name === name) ?? {};
  return (
    <div
      style={{
        minWidth: '400px',
        maxWidth: '500px',
        maxHeight: 'calc(50vh - 10px)',
        overflow: 'scroll',
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <RuleTitle>
        {eventRule.name}{' '}
        {eventRule.source === 'APPLANG_CREATED' ? (
          <Tag color="blue">AI</Tag>
        ) : (
          <Tag color="#F0F0F0" style={{ color: '#1F1F1F' }}>
            Manual
          </Tag>
        )}
      </RuleTitle>
      {eventRule.rules?.[0]?.map((event, index) => (
        <>
          {index !== 0 && <div>OR</div>}
          <EventContainer as={'div'} key={index}>
            <div dangerouslySetInnerHTML={{ __html: formatJSON(event) }} />
          </EventContainer>
        </>
      ))}
    </div>
  );
};

export default EventRuleViewer;
